export default "__VITE_ASSET__105145cb__"